export default "__VITE_ASSET__b403d908__"